import { Routes } from '@angular/router';

import { AuthGuard } from 'authentication';
import { RoutingNames } from 'shared';

export const routes: Routes = [
  {
    path: RoutingNames.authentication,
    loadChildren: () =>
      import('authentication').then((m) =>
        m.authenticationRoutes.filter((route) => route?.path !== RoutingNames.loginOtp),
      ),
  },
  {
    path: 'quiz',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/quiz-page/quiz-page.component').then((m) => m.QuizPageComponent),
  },
  {
    path: 'signup',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/signup-page/signup-page.component').then((m) => m.SignupPageComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'signup',
  },
];
